import { render, staticRenderFns } from "./DSButton.vue?vue&type=template&id=9ef523f0&scoped=true"
import script from "./DSButton.vue?vue&type=script&lang=js"
export * from "./DSButton.vue?vue&type=script&lang=js"
import style0 from "./DSButton.vue?vue&type=style&index=0&id=9ef523f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef523f0",
  null
  
)

export default component.exports